import { Box, CircularProgress, Container, Typography } from '@mui/material';
import { useEventDetails } from '../context';
import NoEventError from './NoEventError';
import EventForm from './EventForm';
import { EVENT_TAB_SCROLL_END_GAP_PX } from 'src/spacing';

interface Props {
    eventId: string;
}

export default function EventProperties(props: Props) {
    const { eventId } = props;
    const { event, isLoading, error } = useEventDetails(eventId);

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" padding={4}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return <Typography color="error">Error loading event details: {error.message}</Typography>;
    }

    if (!event) {
        return <NoEventError eventId={eventId} />;
    }

    return (
        <Container
            maxWidth="md"
            disableGutters
            sx={{
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
                alignItems: 'center',
                paddingBottom: `${EVENT_TAB_SCROLL_END_GAP_PX}px`,
                px: { xs: 2, sm: 3 },
                width: '100%',
                boxSizing: 'border-box',
            }}
        >
            <EventForm eventId={eventId} inTab={true} />
        </Container>
    );
}
